export default __webpack_public_path__ + "static/media/pxgroup01.c47a1bcf.png";